import { useEffect, useState } from "react";

import Swal from "sweetalert2";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import { useDispatch, useSelector } from "react-redux";
import { allRoleFindAction } from "../../../actions/roleMangmentAction";
import { Typography } from "@material-ui/core";
import { Alert, AlertTitle, Skeleton } from "@mui/material";
import ColumnVisible from "../../extraComponents/ColumnVisible";
import { TableData } from "../../Table/Table";
import DownloadPdf from "../../extraComponents/DownloadPdf";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import DownloadExcel from "../../extraComponents/DownloadExcel.js";
import { successTrueMsgAction } from "../../../actions/globalAction.js";
import { SUCCESS_TRUE_MSG_ERR } from "../../../constants/roleManagmentConstant.js";
import Loader from "../../LoaderComponent/Loader.js";
import TableNoItemComponent from "../../customComponent/TableNoItemComponent.js";
import axios from "axios";

function RoleMangment() {
  const dispatch = useDispatch();

  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry] = useState(8);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagiantion] = useState(false)
  const [searchTotalCount, setSearchTotalCount] = useState(1)
  // selectors

  const {
    allRoleFindLoading,
    allRoleFindSuccess,
    allRoleFindErr,
  } = useSelector((state) => {
    return state.allRoleFind;
  });  

  // Selector for BulkUpload

  // const { rollBulkUploadSuccess, rollBulkUploadErr } = useSelector((state) => {
  //   return state.rollBulkUpload;
  // });

  const { rollDeleteSuccess } = useSelector((state) => {
    return state.roleDelete;
  });
  // theme Provider
  let theme = createTheme({
    palette: {
      primary: {
        main: "#0052cc",
      },
      secondary: {
        main: "#edf2ff",
      },
    },
  });

  theme = createTheme(theme, {
    palette: {
      info: {
        main: theme.palette.secondary.main,
      },
    },
  });

  const [roleData, setRoleData] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(allRoleFindAction(pagiantionEntry, paginationPageNumber));
  }, [dispatch, rollDeleteSuccess, pagiantionEntry, paginationPageNumber]);

  // custom Hooks
  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // columnVisibility
  const [showRollNameColumn, setShowRollNameColumn] = useState(false);
  const [showDescriptionNameColumn, setShowDescriptionNameColumn] = useState(false);
  const [showUpdatebyNameColumn, setShowUpdatebyNameColumn] = useState(false);
  const [showLastUpdatebyNameColumn, setShowLastUpdatebyNameColumn] = useState(false);

  const toggleNameColumn = (status, columnName) => {    
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  useEffect(() => {
    if (allRoleFindSuccess) {
      setRoleData(allRoleFindSuccess?.payload);
    }
  }, [allRoleFindSuccess, rollDeleteSuccess]);

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn]) 

  const columns = [
    {
      field: "slno",
      title: "SL NO",
    },
    {
      field: "roleName",
      title: "Role Name",
      // hidden: showRollNameColumn,
    },
    {
      field: "description",
      title: "Description",
      // hidden: showDescriptionNameColumn,
    },
    {
      field: "RoleID",
      title: "RoleID",
      // hidden: showDescriptionNameColumn,
    },
    {
      field: "updateby",
      title: "Updated By",
      // hidden: showUpdatebyNameColumn,
    },
    {
      field: "lastupdateby",
      title: "Last Updated By",
      // hidden: showLastUpdatebyNameColumn,
    },
    {
      field: "action",
      title: "Action",
    },
  ];

  useEffect(() => {
    if (roleData) {
      // let array = roleData.reverse();
      setData(
        roleData.map((data, index) => ({
          id: data.id,
          sl: index + 1,
          name: data.roleName,
          description: data.roleDescription,
          bulkID: data?.bulkUploadId,
          updatedby: "admin",
          lastupdateby: data.createdAt,
        }))
      );
    }
  }, [roleData]);

  const searchHandleChange = async (e) => {
    try {
      const value = encodeURIComponent(e.target.value.trim())
      setSearchPagiantion(true)

      if(value === "") {
        setSearchPagiantion(true)
        dispatch(allRoleFindAction(pagiantionEntry, paginationPageNumber));
      }
      
      let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    const { data } = await axios.get(`/api/admin/role/searchrole?q=${value}&
      limit=${pagiantionEntry}&pagenumber=${paginationPageNumber}&id=${UserId}`, config)

      setSearchTotalCount(data?.totalCount)

      setData(
        data?.payload?.map((data, index) => ({
          id: data.id,
          sl: index + 1,
          name: data.roleName,
          description: data.roleDescription,
          bulkID: data?.bulkUploadId,
          updatedby: "admin",
          lastupdateby: data.createdAt,
        }))
      );

    } catch(error) {
      console.error(error);
    }
  }

  const pdfDownloadClick = () => {
    const excludedFields = ["action"]
    const filteredColumns = columns.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    );  
    DownloadPdf(filteredColumns, data, "Role_Managment", "Role Managment");
  };

  const excelDownloadClick = () => {
    const excludedFields = ["action"]
    const filteredColumns = columns.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    );  

    DownloadExcel(filteredColumns, data, "Role_Managment");
  };

  const paginationDataFetching = (newPage) => {
    try {
      setPaginationPageNumber(newPage)
    } catch(error) {
      console.error(error);
    }
  }

  if (!hasPrivilege("role managment") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <ColumnVisible
          columnVisibleHandler={toggleNameColumn}
          data={data}
          component="role"
          searchHandleChange={searchHandleChange}
          pdfDownloadClick={pdfDownloadClick}
          excelDownloadClick={excelDownloadClick}
          roleRow1={showRollNameColumn}
          roleRow2={showDescriptionNameColumn}
          roleRow3={showUpdatebyNameColumn}
          roleRow4={showLastUpdatebyNameColumn}
          subMenu="role managment"
          column={columns}
          viewedColumn={viewedColumn}
        />

          
          {/* // <>
          //   <Typography variant="h1">
          //     <Skeleton animation={false} />
          //   </Typography>

          //   <Typography variant="h3">
          //     <Skeleton animation="wave" />
          //   </Typography>

          //   <Skeleton animation={false} />
          //   <Typography variant="h3">
          //     <Skeleton animation="wave" />
          //   </Typography>

          //   <Skeleton animation={false} />
          //   <Typography variant="h3">
          //     <Skeleton animation="wave" />
          //   </Typography>

          //   <Skeleton animation={false} />
          //   <Typography variant="h3">
          //     <Skeleton animation="wave" />
          //   </Typography>

          //   <Skeleton animation={false} />
          // </> */}
        {allRoleFindLoading ? (
          <Loader />
        ) : data?.length === 0 ? (
          <TableNoItemComponent />
        ) : (
          <TableData
            data={data}
            columns={columnVisibilityData.length > 0 ? columnVisibilityData : columns}
            allRoleFindSuccess={allRoleFindSuccess}
            showRollNameColumn={showRollNameColumn}
            showDescriptionNameColumn={showDescriptionNameColumn}
            showUpdatebyNameColumn={showUpdatebyNameColumn}
            showLastUpdatebyNameColumn={showLastUpdatebyNameColumn}
            component="role"
            showUrl=""
            pagiantionEntry={pagiantionEntry}
            paginationPageNumber={paginationPageNumber}
            subMenu="role managment"
            paginationDataFetching={paginationDataFetching}
            // totalCount={allRoleFindSuccess?.totalCount}
            totalCount={searchPagination ? searchTotalCount : allRoleFindSuccess?.totalCount}
            viewedColumn={viewedColumn}
          />
        )}
      </ThemeProvider>
    </>
  );
}

export default RoleMangment;
